import { useEffect, useState } from 'react';
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/init";
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { getAppHasAuthenticated, getRequestShop } from '../redux/slices/env';
import { setAppSubscription } from '../redux/slices/app';
import { resetConfigInit, setConfig } from '../redux/slices/config';
import { setNavigation } from '../redux/slices/navigation';

export default function useFetchAppDataFB() {
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const hasAuthenticated = useAppSelector(getAppHasAuthenticated);
  const shop = useAppSelector(getRequestShop);

  useEffect(() => {
    if (!hasAuthenticated || !shop) return;

    // Reset initialization state on shop change
    dispatch(resetConfigInit());

    // 1. Listen to shop settings config
    const configUnsub = onSnapshot(doc(db, `shops/${shop}/settings/config`), (s) => {
      const data = s.data();
      dispatch(setConfig(data || {}));
    }, (error) => console.error("Error listening to config:", error));

    // 2. Listen to root shop document (metadata)
    const shopUnsub = onSnapshot(doc(db, `shops/${shop}`), (_s) => {
      setLoading(false);
    }, (error) => console.error("Error listening to shop doc:", error));

    // 3. Listen to navigation settings
    const navUnsub = onSnapshot(doc(db, `shops/${shop}/settings/navigation`), (s) => {
      const data = s.data();
      dispatch(setNavigation(data || {}));
    }, (error) => console.error("Error listening to navigation:", error));

    // 4. Listen to app subscription document
    const subscriptionUnsub = onSnapshot(doc(db, `shops/${shop}/app/subscription`), (s) => {
      if (s.exists()) {
        dispatch(setAppSubscription(s.data() as any));
      } else {
        dispatch(setAppSubscription(undefined));
      }
    }, (error) => console.error("Error listening to subscription doc:", error));

    return () => {
      configUnsub();
      shopUnsub();
      navUnsub();
      subscriptionUnsub();
    };
  }, [shop, hasAuthenticated, dispatch]);

  return loading;
}

